import { useState } from 'react';
import type { LoadingState } from '../utils/loading/withLoadingIndicator';

export const useLoadingState = (): [
  LoadingState,
  (state: LoadingState) => void,
] => useState<LoadingState>('INITIAL');
